import(/* webpackMode: "eager" */ "/vercel/path0/app/(main)/error.tsx");
